/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from "react"
import { Box, Fade, makeStyles } from "@material-ui/core"
import WifiOffIcon from "@material-ui/icons/WifiOff"

const CONNECTIVITY_CHECK_TIMEOUT_MS = 5000

const useStyles = makeStyles(theme => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginLeft: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 20,
    backgroundColor: "#fff5f5",
    border: "1px solid #ffc9c9",
    color: "#c92a2a",
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    boxShadow: "0 1px 4px rgba(220, 38, 38, 0.1)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem",
      padding: theme.spacing(0.4, 1),
      marginLeft: theme.spacing(1),
    },
    animation: "$pulse 0.75s ease-in-out 5 alternate",
  },
  icon: {
    fontSize: "0.95rem",
    opacity: 0.9,
  },
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.2)" },
    "100%": { transform: "scale(1)" },
  },
}))

const isLocalUrl = url => {
  try {
    const { hostname } = new URL(url)
    return ["localhost", "127.0.0.1", "[::1]"].includes(hostname)
  } catch {
    return true
  }
}

const EXTERNAL_PROBE_URLS = [
  "https://www.gstatic.com/generate_204",
  process.env.REACT_APP_BASE_URL_API,
].filter(url => url && !isLocalUrl(url))

const checkExternalConnectivity = async () => {
  for (const url of EXTERNAL_PROBE_URLS) {
    try {
      const controller = new AbortController()
      const timeoutId = setTimeout(
        () => controller.abort(),
        CONNECTIVITY_CHECK_TIMEOUT_MS
      )
      await fetch(url, {
        method: "HEAD",
        mode: "no-cors",
        cache: "no-store",
        signal: controller.signal,
      })
      clearTimeout(timeoutId)
      return true
    } catch {
      // try next probe
    }
  }

  return false
}

export const Internet = () => {
  const classes = useStyles()
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const verifyWhenNavigatorReportsOffline = async () => {
      const hasExternalConnectivity = await checkExternalConnectivity()
      setIsOnline(hasExternalConnectivity)
    }

    if (navigator.onLine) {
      setIsOnline(true)
    } else {
      verifyWhenNavigatorReportsOffline()
    }

    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)

    return () => {
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])

  if (isOnline) {
    return null
  }

  return (
    <Fade in timeout={300}>
      <Box className={classes.badge} role="alert" aria-live="polite">
        <WifiOffIcon className={classes.icon} fontSize="inherit" />
        Sin conexión a Internet
      </Box>
    </Fade>
  )
}
